import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Report } from '../../interfaces/report.interface';
import { WorkerService } from '../../services/worker.service';

@Component({
    selector: 'app-export-view',
    templateUrl: './export-view.component.html',
    styleUrls: ['./export-view.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportViewComponent implements OnInit {

  @Input() reports: Report[] = [];
  @Input() chapters: any[] = [];
  @Input() categories: any[] = [];
	@Output() closeView = new EventEmitter<any>();

  report_selected: Report = null;
	subs: Subscription[] = [];
  showChapters: boolean = false;
  showCategories: boolean = false;
  showRange: boolean = false;
  chapterSelected: any[] = [];
  categoriesSelected: any[] = [];
  date_from: any;
  date_to: any;
  showFromTo: boolean = false;

  submitForm() {
    let url = this.report_selected.url;
    let name = this.report_selected.name;
    let type = this.report_selected.type;
    let params = this.report_selected.params;
    if (this.showChapters) params.items_ids = this.chapterSelected.map(ch => ch.id).join(',');
    if (this.showCategories) params.category_ids = this.categoriesSelected.map(ct => ct.id).join(',');
    if (this.showRange) {
      params['date_from'] = this.date_from;
      if (this.showFromTo) params['date_to'] = this.date_to;
    }
    this.subs.push(this._wS.reportService(url, params).subscribe(
      (data: any) => {
        let workerData = {
					job_id: data.report ? data.report : data.job_id,
					job_name: name,
					job_type: type
				}
				this._wS.changeWorker(workerData);
        this.closeView.emit();
      }
    ));
  }

  onReportChange(ev) {
    this.report_selected = ev;
    if (this.report_selected.front) this.router.navigateByUrl(`${this.router.url}/` + this.report_selected.url);
    if (this.report_selected.chapters) this.showChapters = true;
    if (this.report_selected.categories) this.showCategories = true;
    if (this.report_selected.range) this.showRange = true;
  }

  close(event) {
		event.stopPropagation();
		this.closeView.emit()
	}

  constructor(
		private _wS: WorkerService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }
}
